var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ImgixImage',{attrs:{"src":_vm.image,"src-options":{
              'h': '107',
              'w': '107',
               fit:'crop', crop:'face'
            },"data-src-options":{h: 108, w: 108, fit:'crop', crop:'face'},"data-srcset":[{
              options: {h: 109, w: 109,  fit:'crop', crop:'face'},
              width: '109w'
              }
            ],"data-sizes":['auto']}})}
var staticRenderFns = []

export { render, staticRenderFns }